import Vue from 'vue';
import { LoadingService } from '@/services/index';
import { EventBus } from '@/event-bus/index';
import { getContentArea } from '@/contentful/index';

export default Vue.extend({
  methods: {
    openInvestmentTransferScreen(params): void {
      LoadingService.watchPromises(getContentArea([
        'investment-transfer-success',
        'investment-transfer-error',
      ])).then((data) => {
        const CONTENT_AREAS = data[0];
        let paramsObj: any = {};
        if (CONTENT_AREAS) {
          if (CONTENT_AREAS[0] && CONTENT_AREAS[0].fields) {
            paramsObj.successMessage = CONTENT_AREAS[0].fields.content;
          }
          if (CONTENT_AREAS[1] && CONTENT_AREAS[1].fields) {
            paramsObj.errorMessage = CONTENT_AREAS[1].fields.content;
          }
        }
        paramsObj = Object.assign(paramsObj, params);
        EventBus.$emit('openOverlayWrapper', 'InvestmentsAccount', paramsObj);
      }).catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
        });
      });
    },
  },
});
